import { Paper, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

/** Wspólna ramka ekranów konta: wąska kolumna, czytelna na telefonie (NFR-U3). */
export function AuthCard({ title, intro, children }: { title: string; intro?: ReactNode; children: ReactNode }) {
  return (
    <Paper withBorder p={{ base: 'md', sm: 'xl' }} radius="md" maw={480} mx="auto" mt="lg">
      <Stack gap="md">
        <Title order={1} size="h2">
          {title}
        </Title>
        {intro ? <Text c="dimmed">{intro}</Text> : null}
        {children}
      </Stack>
    </Paper>
  );
}
